<template>
  <v-card>
    <v-tabs
      background-color="orange darken-3"
      dark
      show-arrows
      style="border-radius: 0"
    >
      <v-tab
        v-for="category in sortedItemBySortNum"
        @click="sortCategory(category.id)"
        :key="category.name_jp"
      >
        {{ $store.state.localeEn ? category.name_en : category.name_jp }}
      </v-tab>
    </v-tabs>
  </v-card>
</template>

<script>
export default {
  name: "ListMenuCategory",
  methods: {
    sortCategory: function (select) {
      this.$store.commit("setSelectedCategory", {
        selectedCategory: select,
      });
      this.selectedCategory = select;
      this.$emit("category", this.$store.state.selectedCategory);
    },
  },
  computed: {
    sortedItemBySortNum() {
      return this.$store.state.categories.slice().sort((a, b) => {
        return a.sortNum < b.sortNum ? -1 : a.sortNum > b.sortNum ? 1 : 0;
      });
    },
  },
};
</script>
